import React, { useState } from "react"
import { getSliceColor } from "./SpinWheel"

const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/
const VISIBLE_LIMIT = 6

const SliceColors = ({ choices, customColors, onColorChange, onResetAll }) => {
  const hasCustomColors = Object.keys(customColors).length > 0
  const hasChoices = choices.length > 0
  const [expanded, setExpanded] = useState(false)
  const visibleChoices = expanded ? choices : choices.slice(0, VISIBLE_LIMIT)
  const hasMore = choices.length > VISIBLE_LIMIT

  return (
    <>
      {hasChoices ? (
        <div className="slice-colors-list">
          {visibleChoices.map((choice, index) => {
            const color = getSliceColor(index, customColors)
            const isCustom = customColors[index] != null
            return (
              <div key={index} className="slice-color-row">
                <div className="slice-color-choice" title={choice}>
                  {choice}
                </div>
                <div className="slice-color-controls">
                  <input
                    type="color"
                    className="slice-color-picker"
                    value={color}
                    onChange={(e) => onColorChange(index, e.target.value)}
                    title="Pick a color"
                  />
                  <input
                    type="text"
                    className="slice-color-hex"
                    value={color.toUpperCase()}
                    onChange={(e) => {
                      const val = e.target.value
                      if (HEX_COLOR_PATTERN.test(val)) {
                        onColorChange(index, val)
                      }
                    }}
                    placeholder="#RRGGBB"
                    maxLength={7}
                  />
                  {isCustom && (
                    <button
                      className="slice-color-reset-btn"
                      onClick={() => onColorChange(index, null)}
                      title="Reset to default"
                    >
                      Reset
                    </button>
                  )}
                </div>
              </div>
            )
          })}
          {hasMore && (
            <button className="slice-colors-toggle" onClick={() => setExpanded((e) => !e)}>
              {expanded ? "Show less" : `Show all ${choices.length} choices`}
            </button>
          )}
        </div>
      ) : (
        <div className="slice-colors-empty">Enter choices to customize colors</div>
      )}
      <div className="choices-input-actions">
        <button
          className="btn-base btn-secondary choices-input-btn choices-input-btn-single"
          onClick={onResetAll}
          disabled={!hasCustomColors}
        >
          Reset All
        </button>
      </div>
    </>
  )
}

export default SliceColors
